.head {
  display: flex;
  align-items: center;
  gap: var(--b-space-8, 8px);
  min-height: var(--b-touch, 44px);
  margin: 0 0 var(--b-space-8, 8px);
}

.title {
  flex: 0 1 auto;
  min-width: 0;
  margin: 0;
  font-size: var(--b-text-lead);
  font-weight: var(--b-weight-title, 650);
  line-height: var(--b-line-snug, 1.3);
}

.count {
  color: var(--text-muted);
  font-size: var(--b-text-small);
  font-weight: 600;
}

.action {
  display: flex;
  align-items: center;
  margin-inline-start: auto;
  font-size: var(--b-text-small);
}

.group {
  min-height: 32px;
  margin-bottom: var(--b-space-4, 4px);
}

.group .title {
  color: var(--text-muted);
  font-size: var(--b-text-meta);
  font-weight: var(--b-weight-strong, 600);
}
